import React from 'react'
import {ApoutUs} from '../components'
const ApoutPage = () => {
    return (
        <main>
            <ApoutUs/>
        </main>
    );
    
}

export default ApoutPage
